
























































































































import { Config } from '@/model/config';
import { Product } from '@/model/product';
import { ProductItemState } from '@/model/product-item-state';
import { VueLoaderService } from '@/util/loader';
import { Util } from '@/util/util';
import Vue from 'vue';
import { ProductPriceStock } from '@/model/product-price-stock';
import { Action } from '@/model/action';

interface VM {
  config: Config;
  ProductItemState: ProductItemState;
  orderAmount: number;
  priceMessage: string;
}

export default Vue.extend({
  name: 'ProductCard',
  components: {
    'warehouse-stock': VueLoaderService.lazyLoadComponent(import('../pps-actions-module/WarehouseStock.vue')),
    'pretty-price': VueLoaderService.lazyLoadComponent(import('../pps-actions-module/PrettyPrice.vue')),
    'heuver-action': VueLoaderService.lazyLoadComponent(import('../../pps-actions-module/HeuverAction.vue')),
    'action-icon': VueLoaderService.lazyLoadComponent(import('../../pps-actions-module/ActionIcon.vue')),
    'product-quantity-selector': VueLoaderService.lazyLoadComponent(import('../pps-actions-module/QuantityInput.vue')),
    'order-button': VueLoaderService.lazyLoadComponent(import('../order-button/OrderButton.vue')),
    'back-order': VueLoaderService.lazyLoadComponent(import('../../back-order/BackOrder.vue'))
  },
  props: {
    product: {
      type: Object as () => Product,
      required: true
    },
    pps: {
      type: Object as () => ProductPriceStock,
      required: true
    },
    actions: {
      type: Array as () => Action[],
      default: []
    },
    quantityDiscounts: {
      type: Array as () => Action[],
      default: []
    }
  },
  computed: {
    ProductItemState() {
      return ProductItemState;
    },
    showActionIcon(): boolean {
      return undefined !== this.actions.find(a => a.isStandardActionType());
    },
    actionIconSource(): string {
      return `${this.config.resourcePath}/dist/img/actions/megaphone-exclamation.svg`;
    },
    firstStaffelAction(): Action | undefined {
      return this.quantityDiscounts.find(a => a.isQuantityDiscountType());
    },
    displayState(): string {
      if (Util.isLoggedIn() == false) return ProductItemState.NOT_LOGGED_IN;

      if (this.product == null || this.pps == null) return ProductItemState.LOGGED_IN_NOT_LOADED;

      if (this.product.isOrderable(this.pps.totalStock, this.pps.itemBaseNetPrice, this.pps.priceOnRequest))
        return ProductItemState.LOGGED_IN_LOADED_ORDER_ABLE;
      else if (this.product.showPriceOnly(this.pps.totalStock, this.pps.itemBaseNetPrice, this.pps.priceOnRequest))
        return ProductItemState.LOGGED_IN_NOT_ORDERABLE_SHOW_PRICE_ONLY;

      return ProductItemState.LOGGED_IN_LOADED_NO_ORDER_ABLE;
    },
    showPriceMessage(): boolean {
      return Util.showEcoTaxMessage(this.product.bu, this.product.productCategory, this.product.itemCondition)
    }
  },
  watch: {
    displayState() {}
  },
  data(): VM {
    return {
      config: Util.getConfig(),
      ProductItemState: ProductItemState,
      orderAmount: 1,
      priceMessage: 'product.order.message.ecoTax'
    };
  }
});
